/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_Api_ReferenceInputs */

const en_directory_footer_link_api_reference = /** @type {(inputs: Directory_Footer_Link_Api_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API reference`)
};

const zh_directory_footer_link_api_reference = /** @type {(inputs: Directory_Footer_Link_Api_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 文档`)
};

/**
* | output |
* | --- |
* | "API reference" |
*
* @param {Directory_Footer_Link_Api_ReferenceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_api_reference = /** @type {((inputs?: Directory_Footer_Link_Api_ReferenceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_Api_ReferenceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_api_reference(inputs)
	return zh_directory_footer_link_api_reference(inputs)
});
export { directory_footer_link_api_reference as "directory.footer.link_api_reference" }